var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-caption",attrs:{"id":"wrapper"}},[_c('span',[_vm._v(_vm._s(_vm.time2line[0]))]),_c('br'),_c('span',{staticClass:"grey--text"},[_vm._v(_vm._s(_vm.time2line[1]))])])
}
var staticRenderFns = []

export { render, staticRenderFns }